import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["monthlyButton", "annualButton", "toggleContainer"]
  static values = {
    billingMethod: String
  }

  connect() {
    // Only show toggle for Stripe billing
    if (this.billingMethodValue !== 'stripe') {
      this.toggleContainerTarget.classList.add('hidden')
      return
    }

    // Show the correct grid based on which plan is selected, or default to monthly
    const annualPlanSelected = document.querySelector('#annual-plans-grid input[type=radio]:checked')
    if (annualPlanSelected) {
      this.showAnnual()
      this.annualButtonTarget.setAttribute('data-selected', 'true')
    } else {
      this.showMonthly()
      this.monthlyButtonTarget.setAttribute('data-selected', 'true')
    }
  }

  selectMonthly(event) {
    event.preventDefault()
    this.showMonthly()
    this.monthlyButtonTarget.setAttribute('data-selected', 'true')
    this.annualButtonTarget.removeAttribute('data-selected')
  }

  selectAnnual(event) {
    event.preventDefault()
    this.showAnnual()
    this.annualButtonTarget.setAttribute('data-selected', 'true')
    this.monthlyButtonTarget.removeAttribute('data-selected')
  }

  showMonthly() {
    document.getElementById('monthly-plans-grid').classList.remove('hidden')
    document.getElementById('annual-plans-grid').classList.add('hidden')
  }

  showAnnual() {
    document.getElementById('monthly-plans-grid').classList.add('hidden')
    document.getElementById('annual-plans-grid').classList.remove('hidden')
  }
} 